// extracted by mini-css-extract-plugin
export var formContainer = "_gz-0";
export var message = "_gz-1";